import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface League {
  id: string;
  name: string;
  country: string;
  api_football_id: number;
  logo_url?: string;
  short_name: string;
}

export function useLeagues() {
  const [leagues, setLeagues] = useState<League[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeagues();
  }, []);

  const fetchLeagues = async () => {
    try {
      const { data, error } = await supabase
        .from('leagues')
        .select('*')
        .order('name');

      if (error) {
        console.error('Error fetching leagues:', error);
        return;
      }

      setLeagues(data || []);
    } catch (error) {
      console.error('Error in fetchLeagues:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    leagues,
    loading,
    refetch: fetchLeagues
  };
}